import React, { useState, useEffect } from "react";
import { ProposalPopup } from "./ProposalPopup.jsx";
import { SharePopup } from "./SharePopup.jsx";
import { Button } from "react-bootstrap";

export function Proposal({ proposal, configuration }) {
  const [popupVisible, setPopupVisible] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [proposalLiked, setProposalLiked] = useState(null);
  let shareButtons = null;

  if (configuration.enableShareButtons) {
    shareButtons = (
      <>
        <Button
          variant="secondary"
          size="sm"
          className="fs-5 share-proposal"
          title={configuration.translations.shareButton}
          onClick={() => setShowShare(true)}
        >
          <i className="fa-solid fa-share-nodes" />
        </Button>
        <SharePopup
          show={showShare}
          onHide={() => setShowShare(false)}
          url={proposal.detail_url}
          text={proposal.name}
          configuration={configuration}
        />
      </>
    );
  }

  const getProposalLiked = () => {
    if (proposal?.total_ok === 1) {
      setProposalLiked("LIKE");
    } else if (proposal?.total_ko === 1) {
      setProposalLiked("DISLIKE");
    } else {
      setProposalLiked(null);
    }
  };
  useEffect(() => {
    getProposalLiked();
  }, [proposal]);

  let answerButtons = "";
  if (configuration.enableAnswerButtons) {
    answerButtons = (
      <>
        <div className="d-flex gap-2 align-items-center">
          <button
            type="submit"
            name="answer"
            className={`btn fs-5 ${
              proposalLiked === "LIKE" ? "btn-success" : "btn-outline-success"
            }`}
            value="1"
            title={configuration.translations.Yes}
            onClick={() => {
              setProposalLiked("LIKE");
            }}
          >
            <i
              className="fa-regular fa-thumbs-up"
              title={configuration.translations.Yes}
            ></i>
          </button>
          <button
            type="submit"
            name="answer"
            className={`btn  fs-5 ${
              proposalLiked === "DISLIKE" ? "btn-danger" : "btn-outline-danger"
            }`}
            value="0"
            title={configuration.translations.No}
            onClick={() => {
              setProposalLiked("DISLIKE");
            }}
          >
            <i
              className="fa-regular fa-thumbs-down"
              title={configuration.translations.No}
            ></i>
          </button>
        </div>
      </>
    );
  }
  let proposalTotalOk = "";
  if (proposal.total_ok) {
    proposalTotalOk = (
      <div className="d-none">
        <span>{proposal.total_ok}</span>
      </div>
    );
  } else {
    proposalTotalOk = (
      <div className="d-none">
        <span>0</span>
      </div>
    );
  }
  let proposalCreator = "";
  if (proposal.creator) {
    proposalCreator = (
      <div className="card-title d-flex flex-row align-items-center gap-3">
        <img
          src={proposal.creator.avatar}
          alt={proposal.creator.name}
          className="rounded-circle img-fluid border shadow-sm"
          height="36"
          width="36"
        />
        <span className="fw-bold">{proposal.creator.name}</span>
      </div>
    );
  } else {
    proposalCreator = (
      <div className="card-title d-flex flex-row align-items-center gap-3">
        <svg
          className="rounded-circle"
          width="36px"
          height="36px"
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
          viewBox="-1 -1 22 22"
        >
          <g fill="#034099">
            <path d="M12.7 19.8H7.3c-1.2 0-2.2-.1-3-.4l-.6-.2.1-.6c.2-2.7 3-4.9 6.3-4.9s6 2.1 6.3 4.9l.1.6-.6.2c-1 .3-2 .4-3.2.4zm-7.4-1.7c.6.1 1.2.2 2 .2h5.4c.7 0 1.4-.1 2-.2-.5-1.7-2.4-2.9-4.7-2.9s-4.1 1.3-4.7 2.9z" />
            <path d="m5.1 19.7-.9-.2c-3.6-1-4-4.3-4-6.7V7.3C.2 2.4 2.3.2 7.3.2h5.4c4.9 0 7 2.1 7 7.1v5.4c0 2.4-.4 5.7-4 6.7l-.9.2-.1-.9c-.2-2-2.3-3.5-4.8-3.5s-4.6 1.5-4.8 3.5v1zm4.9-5.9c2.9 0 5.4 1.7 6.1 3.9 1.5-.7 2.2-2.2 2.2-5V7.3c0-4.1-1.5-5.6-5.5-5.6H7.3c-4.1 0-5.6 1.5-5.6 5.6v5.4c0 2.7.6 4.2 2.2 5 .7-2.3 3.2-3.9 6.1-3.9zm0-1.1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.3-1.8 4-4 4zm0-6.4c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z" />
          </g>
        </svg>
        <span className="fw-bold">Anónimo</span>
      </div>
    );
  }

  function sendProposal(event) {
    console.log("event", event);
    event.preventDefault();
    const proposal = event.target.closest("form");
    const value = event.nativeEvent.submitter.value;
    const url = `/api/v1/proposals/${configuration.proposalsetId}/send_vote/`;
    const data = new FormData(proposal);
    const answer = {
      proposal: data.get("proposal"),
      answer: value,
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": OsoigoNext.getCookie("csrftoken"),
      },
      body: JSON.stringify(answer),
    };
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log(data); // TO DO... en la respuesta del POST tendria que venir actualizado el totalOK, para actualizar ese estado sin realizar un GET a proposal de nuevo.
        } else {
          alert(data.error);
        }
      });
  }

  function truncate(str, n) {
    return str.length > n ? str.slice(0, n - 1) + " &hellip;" : str;
  }

  let proposalLink = null;
  if (configuration.openInPopup) {
    proposalLink = (
      <Button
        variant="link"
        size="sm"
        onClick={() => {
          setPopupVisible(true);
        }}
      >
        {configuration.translations.moreInfo}
      </Button>
    );
  } else {
    proposalLink = (
      <Button href={proposal.detail_url} variant="link" size="sm">
        {configuration.translations.moreInfo}
      </Button>
    );
  }

  return (
    <div
      id={`proposal-${proposal.pk}`}
      className={`card gap-3 p-3 g-col-12 g-col-md-6`}
    >
      {proposalCreator}
      <div className="card-title">
        <p
          className="fs-6"
          dangerouslySetInnerHTML={{ __html: truncate(proposal.name, 70) }}
        ></p>
      </div>
      <div dangerouslySetInnerHTML={{ __html: proposal.listing_body }}></div>
      <form onSubmit={sendProposal} className="d-flex justify-content-between">
        <input type="hidden" name="proposal" value={proposal.pk} />
        {proposalTotalOk}
        {answerButtons}
        {shareButtons}
        {proposalLink}
      </form>
      {popupVisible && (
        <ProposalPopup
          show={popupVisible}
          onHide={() => setPopupVisible(false)}
          proposal={proposal}
          configuration={configuration}
          sendProposal={sendProposal}
          proposalLiked={proposalLiked}
          setProposalLiked={setProposalLiked}
        />
      )}
    </div>
  );
}
